import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import { CourseContentSkeleton } from 'modules/course/components/course-content-skeleton'
import { CourseNeedCompleteModuleScreen } from 'modules/course/components/course-info-screens/course-need-complete-module-screen'
import CourseLayout from 'modules/course/components/course-layout'
import { CourseLecture } from 'modules/course/components/course-lecture'
import { LightCourseLecture } from 'modules/course/components/light-course-lecture'
import { useCourseData } from 'modules/course/hooks/use-course-data'
import useStepRouter from 'modules/course/hooks/use-step-router'
import { getCoursePageLayout } from 'modules/course/layouts/get-course-page-layout'
import { CourseLectureId } from 'modules/course/types/course-lecture-interface'
import { CourseQuizId } from 'modules/course/types/course-quiz-interface'
import { parseQueryId } from 'modules/course/utils/parse-query-id'

const LecturePage = () => {
  const router = useRouter()
  const { lectureId: rawLectureId, previewHash } = router.query
  const lectureId = parseQueryId<CourseLectureId>(rawLectureId)
  const { isPreview } = useStepRouter()
  const getCourseDataQuery = useCourseData()
  const [openPassQuiz, setOpenPassQuiz] = useState<
    false | { blockingStep: CourseLectureId | CourseQuizId }
  >(false)

  useEffect(() => {
    setOpenPassQuiz(false)
  }, [rawLectureId])

  if (getCourseDataQuery.isLoading)
    return (
      <CourseLayout>
        <CourseContentSkeleton />
      </CourseLayout>
    )

  const isLightCourse = getCourseDataQuery.courseData?.courseType === 'light_course'

  return (
    <CourseLayout>
      {openPassQuiz ? (
        <CourseNeedCompleteModuleScreen blockingStep={openPassQuiz?.blockingStep} />
      ) : isLightCourse ? (
        <LightCourseLecture lectureId={lectureId} />
      ) : (
        <CourseLecture
          lectureId={lectureId}
          isPreview={isPreview}
          previewHash={previewHash as string}
          setOpenPassQuiz={setOpenPassQuiz}
        />
      )}
    </CourseLayout>
  )
}

LecturePage.getLayout = getCoursePageLayout

export const getServerSideProps = withDomainAssets(baseServerSideProps)

export default LecturePage
